import React, { useEffect } from "react";
import { Modal, Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

const LogoutSuccessModal = ({ open, onClose }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        onClose();
        navigate("/");
      }, 3000); // 3 seconds

      return () => clearTimeout(timer);
    }
  }, [open, onClose, navigate]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          p: 4,
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          maxWidth: 380,
          mx: "auto",
          mt: "25vh",
          textAlign: "center",
          position: "relative",
        }}
      >
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>

        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
          Success
        </Typography>
        <Typography>You have been signed out.</Typography>
      </Box>
    </Modal>
  );
};

export default LogoutSuccessModal;
